import { OverlayRef } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';

const INITIAL_Z_INDEX: number = 1000;
const MAX_Z_INDEX: number = 2000;

@Injectable()
export class OverlayZIndexService {

	private _zIndexCounter: number = INITIAL_Z_INDEX;
	private readonly _overlayStack: Array<OverlayRef> = [];

	public setZIndex(overlayRef: OverlayRef): void {
		this._overlayStack.splice(
			0,
			this._overlayStack.length,
			...this._overlayStack.filter((ref: OverlayRef) => ref.overlayElement?.isConnected)
		);

		const existingIndex: number = this._overlayStack.indexOf(overlayRef);
		if (existingIndex >= 0) {
			this._overlayStack.splice(existingIndex, 1);
		}
		this._overlayStack.push(overlayRef);

		if (this._zIndexCounter >= MAX_Z_INDEX) {
			this._zIndexCounter = INITIAL_Z_INDEX;
			for (const ref of this._overlayStack) {
				this._zIndexCounter += 1;
				ref.overlayElement.style.zIndex = `${this._zIndexCounter}`;
			}
		}

		this._zIndexCounter += 1;
		overlayRef.overlayElement.style.zIndex = `${this._zIndexCounter}`;
	}

	public reset(): void {
		this._zIndexCounter = INITIAL_Z_INDEX;
		this._overlayStack.length = 0;
	}
}
